import { IkeEnvironment, IkeSystem } from '@ikegps/core-api';
import { IkeConfig } from '../..';
import { OfficeBase } from './office.base';

export const OfficeStaging = new IkeConfig(IkeSystem.OFFICE, IkeEnvironment.STAGING);
const config = OfficeStaging;
config.extend(OfficeBase);

OfficeStaging.set('config.key', 'arn:aws:kms:us-east-1:487538251179:key/af5e8a86-6d0f-4f02-b7fa-080e081ba0c8');
OfficeStaging.set('config.store', 'staging');
OfficeStaging.set('vendor.google.maps', 'AIzaSyA_j7Kpx-R8dPxO29kD6Id0EX724Yj_vZc');
OfficeStaging.set('vendor.google.mapsReleaseChannel', 'weekly');

/*
 * todo: We are not using these parameters as these are injected from Dragon-Server
 * when building. They are injected in index.html and is a static file
 */
OfficeStaging.set('vendor.google.analytics', 'UA-73934200-3');
OfficeStaging.set('vendor.google.tagmanager', 'GTM-KXVM4T4');
